import { render, staticRenderFns } from "./FeatureTourSlide.vue?vue&type=template&id=6c3e50b6&scoped=true&lang=html"
import script from "./FeatureTourSlide.vue?vue&type=script&lang=js"
export * from "./FeatureTourSlide.vue?vue&type=script&lang=js"
import style0 from "./FeatureTourSlide.vue?vue&type=style&index=0&id=6c3e50b6&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3e50b6",
  null
  
)

export default component.exports